export const resetCorners = () => {
  //reset corners before flipping
  document.documentElement.style.setProperty("--cardscan-corner-width", "20%");
  document.documentElement.style.setProperty("--cardscan-corner-height", "20%");
};
